import { read } from "./read"

export const internalNotification = {
  read,
}
